"use client"
import { useEffect } from "react"
import AOS from "aos"

export default function AosProvider() {
  useEffect(() => {
    AOS.init({ once: true, duration: 1000 })
  }, [])
  return null
}
